'use client';

import { TPartner } from '@/domain/Partner.domain';
import { usePartnerStore } from '@/service/state/Partner/usePartnerStore';
import { setupAgentParam } from '@/service/utils/setupAgentParam';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

type TCommonEventsProps = {
    partnerSlug: string;
    partner?: TPartner;
};

export const CommonEvents = ({ partner, partnerSlug }: TCommonEventsProps) => {
    const initPartnerData = usePartnerStore((state) => state.initPartnerData);
    const setupPartner = usePartnerStore((state) => state.setupPartner);
    const getParams = useSearchParams();

    useEffect(() => {
        if (partner) {
            setupPartner(partner);
        } else {
            initPartnerData(partnerSlug);
        }

        const agent = getParams?.get('from');

        if (agent) {
            setupAgentParam(agent);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [partnerSlug]);

    return <></>;
};
